import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Wallet16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M10.25 11V9H11.75V11H10.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.9014 5.25L10.7149 0.470276L9.5 1.25127V1.25H4C2.48122 1.25 1.25 2.48122 1.25 4V12C1.25 13.5188 2.48122 14.75 4 14.75H13.5C14.1904 14.75 14.75 14.1904 14.75 13.5V5.25H13.9014ZM12.0986 5.25L10.2851 2.52977L6.05364 5.25H12.0986ZM3.46577 5.13041C3.04266 4.9301 2.75 4.49923 2.75 4C2.75 3.30964 3.30964 2.75 4 2.75H7.16864L3.46577 5.13041ZM2.75 6.45015V12C2.75 12.6904 3.30964 13.25 4 13.25H13.25V6.75H4C3.54989 6.75 3.12503 6.64186 2.75 6.45015Z'
      fill='currentColor'
    />
  </Svg>
);

Wallet16.displayName = 'Wallet16';
export default Wallet16;
